import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgManageCustomers = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13 18a1 1 0 0 0-.901-.995L12 17a1 1 0 0 0-1 1v2h2v-2zm1-7a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2h4zm0-4a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2h4zm7 2a1 1 0 0 0-.901-.995L20 8h-1v12h1a1 1 0 0 0 1-1V9zM3 19a1 1 0 0 0 1 1h1v-9H4a1 1 0 0 0-1 1v7zM17 5a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v15h2v-2a3 3 0 0 1 3-3l.149.004A3 3 0 0 1 15 18v2h2V5zm2 1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3v-7a3 3 0 0 1 3-3h1V5a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v1z",
		fill: "currentColor"
	})
});
export default SvgManageCustomers;
